<h5>{{title}}</h5>
<div class="row">
    <div class="col-6">
        <mat-form-field appearance="fill" [formGroup]="FormMercancia">
            <mat-label>Seleccione la mercancia </mat-label>
            <mat-select formControlName="mercancia" name="mercancia" (selectionChange)="asingdataForm($event.value)">
                <mat-option [value]="0">
                    Nueva mercancia
                </mat-option>
                <mat-option *ngFor="let mercancia of mercancias" [value]="mercancia?.id">
                    {{mercancia.attributes.nombre}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-6">
        <br>
        <button class="fuse-mat-button-rounded mgbutton" mat-flat-button [disabled]="(this.idMercancia <= 0)"
            (click)="DelMercancia()">Eliminar</button>
        <button class="fuse-mat-button-rounded mgbutton" mat-flat-button [color]="'primary'"
            [disabled]="(this.FormMercancia.invalid)" (click)="saveMercancia()">Guardar</button>
    </div>
</div>

<hr>
<div class="row">
    <div class="col-6">
        <mat-form-field class="" appearance="fill" [formGroup]="FormMercancia">
            <mat-label>Nombre de la mercancia </mat-label>
            <input matInput formControlName="nombre">
            <span class="text-danger" *ngIf="(f.cBienes.touched || submitted) && f.nombre.errors?.required">
                Campo requerido
            </span>
        </mat-form-field>
    </div>
</div>

<div class="row">

    <div class="col-4">
        <div class="border" style="padding: 15px;">
            <div class="row">
                <div class="col-12">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo requerido para expresar la cantidad total de los
                        bienes y/o mercancías que se trasladan a través de los
                        distintos medios de transporte.">
                        <mat-label>Cantidad Bienes| Mercancia <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="cBienes" type="number">
                        <mat-error *ngIf="((f.cBienes.touched || submitted) && f.cBienes.errors?.required)">
                            Campo requerido
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- ***************** START CLAVE BIENES FILTERS *********-->
                <div class="col-12" *ngIf="!rowsetshowClave">
                    <mat-form-field [floatLabel]="'always'" class="margin-8 fuse-mat-emphasized-affix">
                        <mat-label>Clave Bienes| Mercancia <mat-icon class="mat-18">info</mat-icon> <span class="mat-req">*</span></mat-label>
                        <input matInput id="myInputBusquedaClave" name="myInputBusquedaClave"
                            (change)="getProductoServicio($event?.target?.value)"
                            (keyup.enter)="getProductoServicio($event?.target?.value)"
                            placeholder="Palabras clave de búsqueda">
                        <mat-icon>search</mat-icon>
                        <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no
                            encuentras la clave que deseas utilizar buscala <a (click)="btnClave()">aquí</a></mat-hint>
                        <mat-error class="mt-4" *ngIf="!isValidClave">
                            Campo requerido
                        </mat-error>                       
                    </mat-form-field>
                    <div class="col-12">  
                            <smal class="mat-req mat-txt" *ngIf="!isValidClave">
                                Campo requerido
                            </smal> 
                        
                    </div>
                </div>
                <div class="col-12" *ngIf="rowsetshowClave">
                    <mat-form-field class="margin-8 example-full-width" appearance="fill" [floatLabel]="'always'">
                        <mat-label>Clave Bienes| Mercancia <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input type="text" id="myInputClave" [formControl]="myControl" name="myInputClave"
                            placeholder="seleccione una opción" aria-label="Number" matInput required
                            [matAutocomplete]="autoCBienes">
                        <mat-autocomplete #autoCBienes="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)="selectedProductoServicio($event?.option?.value)">
                            <ng-container *ngIf="optionSAT">
                                <mat-option *ngFor="let option of optionSAT" [value]="option">
                                    {{option?.attributes?.clave}}-{{option?.attributes?.descripcion}}

                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                        <mat-error *ngIf="(myControl.invalid && myControl.touched)">Campo requerido</mat-error>
                        <mat-icon svgIcon="mat_solid:close" (click)="eraseClaveSat()"></mat-icon>
                        <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no
                            encuentras la clave que deseas utilizar buscala <a (click)="btnClave()">aquí</a></mat-hint>

                        <mat-error *ngIf="(f.claveBienes.invalid || f.claveBienes.errors?.required)">
                            Campo requerido
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- ****************** FIN CLABE BIENES FILTERS *******************-->
                <div class="col-12">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo requerido para detallar las características de
                    los bienes y/o mercancías que se trasladan en los
                    distintos medios de transporte.">
                        <mat-label>Descripción Bienes|Mercancia <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="dBienes">
                        <mat-error *ngIf="((f.dBienes.touched || submitted) && f.dBienes.errors?.required)">
                            Campo requerido
                        </mat-error>
                    </mat-form-field>
                    
                </div>
                <!-- **************************** INICIA CLAVE UNIDAD FILTERS ***********************-->
                <div class="col-12" *ngIf="!rowsetshowUnidad">
                    <mat-form-field [floatLabel]="'always'">
                        <mat-label>Clave Unidad <mat-icon class="mat-18">info</mat-icon> <span class="mat-req">*</span></mat-label>
                        <input matInput (change)="GetSelUnidadMedia($event?.target?.value)"
                            (keyup.enter)="GetSelUnidadMedia($event?.target?.value)" id="myInputBusquedaUnidad"
                            name="myInputBusquedaUnidad" placeholder="Palabras clave de búsqueda">
                        <mat-icon>search</mat-icon>
                        <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no
                            encuentras la clave que deseas utilizar buscala <a (click)="btnUnidad()">aquí</a></mat-hint>
                        <!-- <mat-error *ngIf="!isValidUnidad">
                            Campo requerido
                        </mat-error> -->
                    </mat-form-field>
                    <div class="col-12">  
                        <smal class="mat-req mat-txt" *ngIf="!isValidUnidad">
                            Campo requerido
                        </smal> 
                    
                </div>
                </div>
                <div class="col-12" *ngIf="rowsetshowUnidad">
                    <mat-form-field class="example-full-width" appearance="fill" [floatLabel]="'always'">
                        <mat-label>Clave Unidad <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input type="text" placeholder="seleccione una opción" id="myInputUnidad" name="myInputUnidad"
                            aria-label="Number" matInput [formControl]="myControlUnidadMedida" required
                            [matAutocomplete]="autoUnidad">
                        <mat-autocomplete #autoUnidad="matAutocomplete"
                            (optionSelected)="onUnidadMedidaSelected($event?.option?.value)"
                            [displayWith]="displayFnUnidadMedida">
                            <ng-container *ngIf="unidadMedida">
                                <mat-option *ngFor="let opt of unidadMedida" [value]="opt">
                                    {{opt?.attributes?.clave}}-{{opt?.attributes?.descripcion}}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                        <mat-error *ngIf="myControlUnidadMedida.invalid && myControlUnidadMedida.touched">*Este campo es
                            obligatorio.</mat-error>
                        <mat-hint class="text-12 mat-hint mat-form-field-hint-end ng-tns-c32-35" id="mat-hint-0">Sí no
                            encuentras la clave que deseas utilizar buscala <a (click)="btnUnidad()">aquí</a></mat-hint>
                        <mat-icon svgIcon="mat_solid:close" (click)="eraseUnidad()"></mat-icon>
                    </mat-form-field>
                </div>
                <!-- ******************* FIN CLAVE UNIDAD FILTERS ***********************-->
                <div class="col-12">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo opcional para registrar la unidad de medida
                    propia para la cantidad de los bienes y/o mercancías
                    que se trasladan a través de los distintos medios de
                    transporte. La unidad debe corresponder con la
                    descripción de los bienes y/o mercancías.">
                        <mat-label>Unidad <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="unidad">
                    </mat-form-field>
                </div>

            </div>
        </div>
    </div>
    <div class="col-8">
        <div class="border" style="padding: 15px;">
            <div class="row">
                <div class="col-2">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo condicional para precisar que los bienes y/o
                        mercancías que se trasladan son considerados o
                        clasificados como material peligroso.">
                        <mat-label>Material Peligroso <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <mat-select name="mPeligroso" formControlName="mPeligroso"
                            (ngModelChange)="fnMaterialPeligroso( $event )">
                            <mat-option *ngFor="let mpeligroso of mpeligrosos" [value]="mpeligroso.id">
                                {{mpeligroso.nombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-3">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo condicional para indicar la clave del tipo de
                        material peligroso que se transporta de acuerdo a la
                        NOM-002-SCT/2011.">
                        <mat-label>CveMaterialPeligroso <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="cveMPeligroso" type="number">
                    </mat-form-field>
                </div>
                <div class="col-7">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo condicional para precisar la clave del tipo de
                        embalaje que se requiere para transportar el material o
                        residuo peligroso.">
                        <mat-label>Embalaje <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <mat-select name="embalaje" formControlName="emabalaje">
                            <mat-option *ngFor="let embalaje of embalajes" [value]="embalaje.id">
                                {{embalaje.attributes.nombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo requerido para indicar en kilogramos el peso
                        estimado de los bienes y/o mercancías que se trasladan
                        en los distintos medios de transporte.">
                        <mat-label>Peso en Kg <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="pesokg" type="number">
                        <mat-error *ngIf="(f.pesokg.touched || submitted) && f.pesokg.errors?.required">
                            Campo requerido
                        </mat-error>
                    </mat-form-field>
                </div>
                <!--Valor Mercancia-->
                <div class="col-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo condicional para expresar el monto del valor de
                        los bienes y/o mercancías que se trasladan en los
                        distintos medios de transporte, de acuerdo al valor
                        mercado, al valor pactado en la contraprestación o bien
                        al valor estimado que determine el contribuyente.">
                        <mat-label>Valor Mercancia <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="valorM" type="number">
                    </mat-form-field>
                </div>
                <!--Dimensiones-->
                <div class="col-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo opcional para expresar las medidas del
                        empaque de los bienes y/o mercancías que se
                        trasladan en los distintos medios de transporte. Se debe
                        registrar la longitud, la altura y la anchura en
                        centímetros o en pulgadas, separados dichos valores
                        con una diagonal, i.e. 30/40/30cm.">
                        <mat-label>Dimensiones <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input appCustomMask matInput formControlName="Dimen">
                        <!-- <input matInput formControlName="Dimen" mask="000/000/000" suffix="cm">-->
                        <mat-hint>Formato: Largo/Alto/Ancho cm</mat-hint>
                    </mat-form-field>
                </div>
                <!--Moneda-->
                <div class="col-6">
                    <!-- <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo condicional para identificar la clave de la
                        moneda utilizada para expresar el valor de los bienes
                        y/o mercancías que se trasladan en los distintos medios
                        de transporte. Cuando se usa moneda nacional se
                        registra MXN, de acuerdo a la especificación ISO 4217.">
                        <mat-label>Moneda <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <mat-select name="moneda" formControlName="moneda">
                            <mat-option *ngFor="let moneda of monedas" [value]="moneda.idMoneda">
                                {{moneda.nombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->

                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo condicional para identificar la clave de la
                    moneda utilizada para expresar el valor de los bienes
                    y/o mercancías que se trasladan en los distintos medios
                    de transporte. Cuando se usa moneda nacional se
                    registra MXN, de acuerdo a la especificación ISO 4217.">
                        <mat-label>Moneda <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput aria-label="State" matInput formControlName="moneda"
                            [matAutocomplete]="autoMoneda">
                        <mat-autocomplete #autoMoneda="matAutocomplete" [displayWith]="displayFnMoneda">
                            <mat-option *ngFor="let moneda of opcionesFiltradasMonedas | async" [value]="moneda.id"
                                style="height: 35px;">
                                <span>{{ moneda.attributes.clave }}-{{ moneda.attributes.descripcion }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <!--FraccionArancelaria-->
                <div class="col-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'"
                        matTooltip="Atributo condicional que sirve para expresar la clave de
                        la fracción arancelaria que corresponde con la
                        descripción de los bienes y/o mercancías que se
                        trasladan en los distintos medios de transporte. la clave esta compuesta de 10 caracteres, favor de verificar que sea catalogo actualizado">
                        <mat-label>Fraccion Arancelaria <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="fArancelaria">
                    </mat-form-field>

                </div>
                <!--UUIDComercioExt-->
                <div class="col-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMercancia"
                        [matTooltipPosition]="'above'" matTooltip="Atributo opcional para expresar el folio fiscal (UUID) del
                        comprobante de comercio exterior que se relaciona.">
                        <mat-label>UUID Comercio Ext <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="uuidComercio">
                    </mat-form-field>
                </div>
            </div>
        </div>

    </div>
</div>
<!-- <div class="row">
    <div class="col-12">
        {{this.FormMercancia.value| json}}
    </div>
</div> -->

<!-- Pedimentos -->
<div *ngIf="idMovimiento==1">
    <h5>Pedimentos</h5>
    <div class="row justify-content-start align-items-center barraGestorPagos">
        <div class="col-sm-12 col-md-1 col-xl-1">
            <button (click)="addGuiaP()" mat-flat-button color="primary">
                <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
            </button>
        </div>
        <div class="col-sm-12 col-md-1 col-xl-1">
            <button (click)="removeGuiaP()" [disabled]="removeDisabledGuiaP" mat-flat-button color="warn">
                <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
            </button>
        </div>
    </div>
    <app-pedimentos *ngFor="let p of countGuiasP" [pedimento]="p"></app-pedimentos>
</div>
<!--Guia Identificacion-->
<h5 class="mt-4">Guia Identificación</h5>
<div class="row justify-content-start align-items-center barraGestorPagos mt-4">
    <div class="col-sm-12 col-md-1 col-xl-1">
        <button (click)="addGuiaI()" mat-flat-button color="primary">
            <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
        </button>
    </div>
    <div class="col-sm-12 col-md-1 col-xl-1">
        <button (click)="removeGuiaI()" [disabled]="removeDisabledGuiaI" mat-flat-button color="warn">
            <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
        </button>
    </div>
</div>
<app-guia-identificacion *ngFor="let p of countGuiasI" [title]="p.id" [data]="p.data"
    (FormGuiaIdentificacionEventEmiter)="FormGuiaIdentificacionEventEmiter($event)"></app-guia-identificacion>

<!--Guia Transporte-->
<h5 class="mt-4">Guia Transporte</h5>
<div class="row justify-content-start align-items-center barraGestorPagos mt-4">
    <div class="col-sm-12 col-md-1 col-xl-1">
        <button (click)="addTransporte()" mat-flat-button color="primary">
            <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
        </button>
    </div>
    <div class="col-sm-12 col-md-1 col-xl-1">
        <button (click)="removeTransporte()" [disabled]="removeDisabledTransporte" mat-flat-button color="warn">
            <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
        </button>
    </div>
</div>
<app-guia-transporte *ngFor="let p of countTransporte" [title]="p.id" [data]="p.data"
    (FormGuiaTransporteEventEmiter)="FormGuiaTransporteEventEmiter($event)"></app-guia-transporte>